import { Music, Users, Calendar, Search, Award, Mic } from 'lucide-react';
import SEOLandingPage from '../../components/seo/SEOLandingPage';

export default function BandFindenSchweiz() {
  return (
    <SEOLandingPage
      title="Band finden in der Schweiz | jamnation - Schweizer Bands entdecken"
      description="Entdecke Schweizer Bands auf jamnation. Finde die perfekte Band für dein Event, Festival oder Location. Rock, Pop, Jazz, Metal und mehr aus der ganzen Schweiz."
      h1="Band finden in der Schweiz"
      heroText="Entdecke die besten Bands aus der ganzen Schweiz. Ob für dein Event, deine Location oder einfach zum Entdecken neuer Musik – hier findest du Bands aus allen Genres und Regionen."
      keywords={[
        'band finden schweiz',
        'band suchen schweiz',
        'schweizer bands',
        'liveband schweiz',
        'coverband schweiz',
        'partyband schweiz',
        'hochzeitsband schweiz',
        'band buchen schweiz',
      ]}
      locationName="Schweizweit"
      ctaButtons={[
        {
          text: 'Alle Bands entdecken',
          link: '/bands',
          primary: true,
        },
        {
          text: 'Band buchen',
          link: '/book-band',
        },
      ]}
      features={[
        {
          icon: Search,
          title: 'Umfangreiche Bandsuche',
          description:
            'Finde Bands nach Genre, Standort, Besetzung und Erfahrung. Unsere Filter helfen dir, genau die richtige Band zu finden.',
          link: '/bands',
        },
        {
          icon: Music,
          title: 'Alle Musikrichtungen',
          description:
            'Rock, Pop, Jazz, Metal, Punk, Indie, Electronic, Country und mehr. Schweizer Bands für jeden Geschmack und Anlass.',
          link: '/bands',
        },
        {
          icon: Calendar,
          title: 'Live-Events',
          description:
            'Sieh dir an, wo und wann Bands auftreten. Entdecke Konzerte in deiner Nähe und erlebe Schweizer Live-Musik.',
          link: '/agenda',
        },
        {
          icon: Mic,
          title: 'Soundbeispiele & Videos',
          description:
            'Höre dir Sounds an und schaue Videos, bevor du Kontakt aufnimmst. So weisst du genau, was dich erwartet.',
          link: '/bands',
        },
        {
          icon: Users,
          title: 'Von Cover bis Original',
          description:
            'Coverbands für Events, Originalbands für Konzerte – hier findest du beide. Mit detaillierten Repertoire-Infos.',
          link: '/bands',
        },
        {
          icon: Award,
          title: 'Geprüfte Bands',
          description:
            'Alle Bands mit vollständigen Profilen, Setlists und Erfahrungsberichten. Transparenz für die beste Auswahl.',
          link: '/bands',
        },
      ]}
      teaserSection={{
        title: 'Was du auf jamnation alles tun kannst',
        description:
          'jamnation vereint die gesamte Schweizer Musikszene auf einer Plattform. Entdecke Bands, veröffentliche Events und werde Teil der Community.',
        items: [
          'Durchsuche hunderte Schweizer Bands aus allen Genres',
          'Höre Soundbeispiele und schaue Videos vor der Kontaktaufnahme',
          'Buche Bands direkt für dein Event ohne Agentur-Provision',
          'Erstelle ein Bandprofil und werde schweizweit gefunden',
          'Veröffentliche Konzerte und erreiche mehr Publikum',
          'Vernetze dich mit Bands, Musikern und Fans aus der ganzen Schweiz',
        ],
      }}
      seoTeaser={{
        title: 'Schweizer Bands auf einen Blick',
        description:
          'Von Basel bis Lugano, von Genf bis St. Gallen – jamnation bringt die gesamte Schweizer Bandszene zusammen. Egal ob du eine Hochzeitsband in der Romandie suchst, eine Rockband für ein Festival im Mittelland brauchst oder eine Jazz-Formation für ein Event in der Deutschschweiz: Auf unserer Plattform findest du Bands aus allen Regionen und allen Genres. Mit intelligenten Suchfiltern, Soundbeispielen und direkter Kontaktmöglichkeit wird die Bandsuche einfach und effizient. Entdecke neue Schweizer Musik, buche etablierte Acts für dein Event oder erstelle selbst ein Bandprofil und werde schweizweit gefunden. jamnation ist die grösste Musikerplattform der Schweiz – kostenlos und für alle zugänglich.',
      }}
      faqItems={[
        {
          question: 'Wie finde ich die passende Band für mein Event?',
          answer:
            'Nutze unsere Filteroptionen, um nach Genre, Standort und Bandgrösse zu suchen. Höre dir die Soundbeispiele an und kontaktiere Bands direkt über ihr Profil.',
        },
        {
          question: 'Kann ich Bands für private Events buchen?',
          answer:
            'Ja! Viele Bands auf jamnation spielen bei Hochzeiten, Geburtstagen, Firmenevents und privaten Feiern. Kontaktiere sie direkt für eine Anfrage.',
        },
        {
          question: 'Gibt es auch Cover-Bands auf jamnation?',
          answer:
            'Absolut! Du findest sowohl Original-Bands als auch Cover-Bands, die bekannte Songs spielen. Viele Bands bieten beides an.',
        },
        {
          question: 'Wie viel kostet es, eine Band zu buchen?',
          answer:
            'Die Preise variieren je nach Band, Event-Typ und Dauer. Am besten kontaktierst du die Bands direkt für ein individuelles Angebot.',
        },
        {
          question: 'Sind die Bands professionell?',
          answer:
            'Auf jamnation findest du sowohl ambitionierte Hobby-Bands als auch professionelle Vollzeit-Musiker. Die Profile geben dir Aufschluss über Erfahrung und bisherige Auftritte.',
        },
        {
          question: 'Kann ich auch als Band gefunden werden?',
          answer:
            'Ja! Erstelle kostenlos ein Bandprofil mit Fotos, Sounds, Videos und allen wichtigen Infos. So können dich Veranstalter und Fans finden.',
        },
      ]}
    />
  );
}
